<template>
  <div
    class="custom-header"
    :class="[
      customSorting && column.property === sortProp ? sortOrder : '',
      column.sortable === false ? '' : 'no-sort',
    ]"
    @click="handlerCustomHeader"
  >
    <div class="text">
      <span class="title">{{ column.label }}{{ getCurrencyLabel(findFieldCol) }}</span>
    </div>

    <!-- slot="reference"  -->
    <span
      v-if="customSorting"
      class="custom-sorting"
    >
      <UiIcon
        name="caret-down"
        :size="14"
        color="#ffffff"
        class="asc"
        style="transform: rotate(180deg)"
      />
      <UiIcon
        name="caret-down"
        :size="14"
        color="#ffffff"
        class="desc"
        style="margin-top: -9px;"
      />
    </span>

    <span
      :class="{ 'open-filters': openFilter }"
      class="filters-wrapper"
    >
      <ElPopover
        v-if="filterable && isFiltersInit"
        class="col-filter"
        trigger="click"
        width="auto"
        :visible="columnFilters[column.property].visible"
      >
        <div class="col-filter-wrapper">
          <UiTabs
            v-if="showTabs"
            v-model="columnFilters[column.property].op"
            :list="Array.isArray(allowedOperators) ? allowedOperators : []"
            @change="handlerRadioBtn"
          />
          <div
            :class="filterInputHiddenClass"
            class="input-filter-wrap-gen2"
          >
            <div class="input-filter-wrap-gen2__title-wr">
              <span>{{ $t('ui.table.from') }}</span>
              <span>{{ $t('ui.table.to') }}</span>
            </div>
            <div
              v-if="columnFilters[column.property].valueRange"
              class="input-filter-wrap-gen2__input-wr"
              :class="focusInput ? 'focus' : ''"
            >
              <UiInput
                class="filter-input filter-input-num filter-input-num__range"
                placeholder="-∞"
                :model-value="columnFilters[column.property].valueRange[0]"
                type="number"
                borderless
                @focus="focusInput = true"
                @blur="focusInput = false"
                @update:model-value="handlerRangeValue($event, 'dataRange[0]')"
              />
              <span>-</span>
              <UiInput
                class="filter-input filter-input-num filter-input-num__range"
                placeholder="+∞"
                :model-value="columnFilters[column.property].valueRange[1]"
                type="number"
                borderless
                @focus="focusInput = true"
                @blur="focusInput = false"
                @update:model-value="handlerRangeValue($event, 'dataRange[1]')"
              />
            </div>
            <UiCheckbox
              :model-value="columnFilters[column.property].isExclude"
              :label="columnFilters[column.property].valueRange &&
                columnFilters[column.property].valueRange[1] &&
                columnFilters[column.property].valueRange[0]
                ? $t('ui.table.exclude')
                : $t('ui.table.exclude2')"
              class="t:mb-8"
              @change="changeExclude"
            />
          </div>

          <UiInput
            v-if="customFilterColumn.indexOf(column.property) >= 0"
            class="filter-input filter-input-date"
            :placeholder="$t('ui.table.value')"
            :model-value="columnFilters[column.property].valueSec"
            @update:model-value="handlerColumnFilterInput($event, 'date')"
          />
          <UiDatePicker
            v-if="customFilterColumnCreated.includes(column.property)"
            v-model="columnFilters[column.property].dateRange"
            class="render-header__datepicker"
            :disabled="columnFilters[column.property].op === ''"
            :placeholder="isDaterangePicker ? $t('reports.other.start_end_date') : $t(`team_popup.see_stats_placeholder`)"
            :multi-calendars="isDaterangePicker"
            :range="isDaterangePicker "
            :always-clearable="false"
            :clearable="false"
            auto-apply
            :ui="{
              menu: 'render-header__datepicker-menu'
            }"
            @update:model-value="isDaterangePicker ? handlerDatepickerRange($event, 'daterange') : handlerDatepickerRange($event, 'date')"
          />
          <UiSelect
            v-if="customFilterColumn.indexOf(column.property) >= 0"
            class="filter-select"
            :placeholder="$t('affiliates.offersView.holdRanges.seconds')"
            :model-value="createValueSelect()"
            :options="optionsFilterSelect"
            @update:model-value="handlerColumnFilterInput($event, 'select')"
          />

          <div class="btns">
            <UiButton
              type="negative"
              icon="times"
              @click="handlerResetBtn"
            >{{
              $t('ui.table.reset')
            }}</UiButton>
            <!-- && columnFilters[column.property].op -->
            <UiButton
              icon="check"
              :disabled="
                !readyFilter && !columnFilters[column.property].valueSec && !columnFilters[column.property].dateRange
              "
              @click="handlerSuccessBtn"
            >{{ $t('ui.table.apply') }}</UiButton>
          </div>
        </div>

        <template v-slot:reference>
          <div
            :class="{
              open:
                lastOpenFilter === column.property ||
                ((columnFilters[column.property].value || columnFilters[column.property].dateRange !== null) &&
                  columnFilters[column.property].op),
            }"
            class="filter-opener"
            @click.stop="handlerFilter"
          >
            <UiIcon
              substyle="fas"
              name="filter"
              :size="8"
            />
          </div>
        </template>
      </ElPopover>
    </span>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapGetters } from 'vuex';

export default {
  name: 'RenderHeader',
  props: {
    currency: {
      type: String,
      default: '',
    },
    column: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    customSorting: {
      type: Boolean,
      default: false,
    },
    sortProp: {
      type: String,
      required: true,
    },
    sortOrder: {
      type: String,
      required: true,
    },
    lastOpenFilter: {
      type: String,
      required: true,
    },
    columnFilters: {
      type: Object,
      required: true,
    },
    isFiltersInit: {
      type: Boolean,
      required: true,
    },
    customFilterColumn: {
      type: Array,
      required: true,
    },
    customFilterColumnCreated: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'handleSort',
    'lastOpenFilter',
    'handlerColumnFilterInput',
    'handlerRangeValue',
    'handlerDatepickerRange',
    'setCheckApplyFilter',
    'filter',
    'changeColumnFilters',
    'handlerRadioBtn',
    'changeExclude',
  ],

  data() {
    return {
      focusInput: false,
      readyFilter: false,
      optionsFilterSelect: [
        {
          label: this.$t('affiliates.offersView.holdRanges.minutes'),
          value: 'minutes',
        },
        {
          label: this.$t('affiliates.offersView.holdRanges.hours'),
          value: 'hours',
        },
        {
          label: this.$t('affiliates.offersView.holdRanges.days'),
          value: 'days',
        },
        {
          label: this.$t('affiliates.offersView.holdRanges.weeks'),
          value: 'weeks',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      currencies: 'misc/currencies',
    }),
    isDaterangePicker() {
      return this.columnFilters[this.column.property].op === '=';
    },
    findFieldCol() {
      return this.fields.find((el) => el.name === this.column.property);
    },

    filterable() {
      return this.findFieldCol !== undefined ? this.findFieldCol.filterable || false : false;
    },

    allowedOperators() {
      return this.findFieldCol !== undefined ? this.findFieldCol.allowedOperators || ['<', '=', '>'] : ['<', '=', '>'];
    },

    filterInputType() {
      return this.findFieldCol !== undefined ? this.findFieldCol.filterInputType || 'text' : 'text';
    },

    openFilter() {
      return (
        this.columnFilters[this.column.property]
        && (this.lastOpenFilter === this.column.property
          || ((this.columnFilters[this.column.property].value
            || this.columnFilters[this.column.property].dateRange !== null)
            && this.columnFilters[this.column.property].op))
      );
    },

    filterInputHiddenClass() {
      return this.customFilterColumn.indexOf(this.column.property) >= 0
        || this.customFilterColumnCreated.includes(this.column.property)
        ? 'filter-input__hide'
        : '';
    },

    showTabs() {
      return this.customFilterColumnCreated.includes(this.column.property)
        ? this.customFilterColumnCreated.includes(this.column.property)
        : this.customFilterColumn.indexOf(this.column.property) >= 0;
    },
  },

  methods: {
    getCurrencyLabel(field) {
      if (field?.currencyKey) {
        return '';
      }

      if (this.currency && [
        'currency',
        'formatMoney',
        '-formatMoney',
        'ncurrency',
        '-ncurrency',
      ].includes(field?.format)) {
        const currency = this.currencies.find(((el) => el.code === this.currency));

        return `, ${currency?.symbol || this.currency}`;
      }

      return '';
    },
    changeExclude(checked) {
      this.$emit('changeExclude', this.column.property, checked);
      this.checkReadyFilter();
    },

    handlerRadioBtn(value) {
      this.$emit('handlerRadioBtn', this.column.property, value);
    },

    handlerFilter() {
      const columnFiltersClone = this.columnFilters;
      const set = !columnFiltersClone[this.column.property].visible;

      columnFiltersClone[this.column.property].visible = set;

      if (set) {
        if (this.lastOpenFilter) {
          columnFiltersClone[this.lastOpenFilter].visible = false;
        }
        this.$emit('changeColumnFilters', columnFiltersClone);
        this.$emit('lastOpenFilter', this.column.property);
      } else {
        this.$emit('changeColumnFilters', columnFiltersClone);
        this.$emit('lastOpenFilter', '');
      }
    },

    toValueAndOp(valueRange, isExclude) {
      if (valueRange[0] !== '' && valueRange[1] !== '') {
        return {
          value: [valueRange[0], valueRange[1]],
          op: isExclude ? 'notBetween' : 'between',
        };
      }
      if (valueRange[0] !== '') {
        return {
          value: valueRange[0],
          op: isExclude ? '>' : '>=',
        };
      }
      return {
        value: valueRange[1],
        op: isExclude ? '<' : '<=',
      };
    },

    handlerSuccessBtn() {
      const columnFiltersClone = this.columnFilters;
      columnFiltersClone[this.column.property].visible = false;

      if (this.filterInputHiddenClass !== 'filter-input__hide') {
        const { valueRange } = columnFiltersClone[this.column.property];
        const { isExclude } = columnFiltersClone[this.column.property];

        columnFiltersClone[this.column.property].op = this.toValueAndOp(valueRange, isExclude).op;
        columnFiltersClone[this.column.property].value = this.toValueAndOp(valueRange, isExclude).value;
      }

      this.$emit('lastOpenFilter', '');
      this.$emit('filter', columnFiltersClone);
      this.$emit('setCheckApplyFilter', true);
      this.$nextTick(() => {
        this.$emit('setCheckApplyFilter', false);
      });
      this.readyFilter = false;
    },

    handlerResetBtn() {
      const columnFiltersClone = this.columnFilters;
      columnFiltersClone[this.column.property].op = '';
      columnFiltersClone[this.column.property].value = '';
      columnFiltersClone[this.column.property].valueRange = ['', ''];
      columnFiltersClone[this.column.property].isExclude = false;
      columnFiltersClone[this.column.property].valueSec = '';
      columnFiltersClone[this.column.property].dateFilter = '';
      columnFiltersClone[this.column.property].dateRange = null;
      columnFiltersClone[this.column.property].visible = false;
      this.$emit('lastOpenFilter', '');
      this.$emit('filter', columnFiltersClone, 'reset');
      this.$emit('setCheckApplyFilter', true);
      this.$nextTick(() => {
        this.$emit('setCheckApplyFilter', false);
      });
    },

    handlerDatepickerRange(date, type) {
      const formatDate = () => {
        if(date) {
          if (type === 'daterange') {
            return date.map((elem) => format(elem, 'yyyy-MM-dd'));
          }
          return format(date, 'yyyy-MM-dd');
        } else {
          return date;
        }
      };
      this.$emit('handlerDatepickerRange', this.column.property, formatDate());
    },

    handlerRangeValue(val, type) {
      this.$emit('handlerRangeValue', type, this.column.property, val.replace());
      this.checkReadyFilter();
    },

    checkReadyFilter() {
      this.readyFilter = !!(
        this.columnFilters[this.column.property].valueRange[0] || this.columnFilters[this.column.property].valueRange[1]
      );
    },

    handlerColumnFilterInput(val, type) {
      this.$emit('handlerColumnFilterInput', type, this.column.property, val);
    },

    handlerCustomHeader() {
      if (this.filterable) {
        if (this.lastOpenFilter) {
          this.columnFilters[this.lastOpenFilter].visible = false;
          this.$emit('lastOpenFilter', '');
        }
      }

      if (this.column.sortable || this.customSorting) {
        const paramSort = [
          {
            prop: this.column.property,
            order: this.sortOrder === 'asc' ? 'desc' : 'asc',
          },
          this.column.id,
        ];

        this.$emit('handleSort', ...paramSort);
      }
    },

    createValueSelect() {
      return (
        this.columnFilters[this.column.property].dateFilter
        || `${
          this.customFilterColumn.indexOf(this.column.property) >= 0
            ? (this.columnFilters[this.column.property].dateFilter = 'hours')
            : ''
        }`
      );
    },
  },
};
</script>

<style lang="scss">
.render-header__datepicker{
  margin: 8px 0;
  width: 230px;
}
.input-filter-wrap-gen2 {
  display: flex;
  flex-direction: column;
  &__title-wr {
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    span {
      font-size: 12px;
    }
  }
  &__input-wr {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    border-radius: 4px;

    border: 1px solid var(--border-default);
    &.focus {
      border: 1px solid var(--border-focused);
    }
    .filter-input-num__range {
      margin: 0;
      &.focus .input-wrapper {
        border-color: transparent !important;
      }
      .input-wrapper {
        border-color: transparent !important;
      }
      .ui-input__element {
        text-align: center;
        min-width: 84px;
        width: 90px;
        border-color: transparent;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          /* display: none; <- Crashes Chrome on hover */
          -webkit-appearance: none;
          margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
        }
        &::placeholder {
          font-size: 17px !important;
        }
      }
    }
  }
  &__checkbox {
    margin-bottom: 8px;
    .el-checkbox__label {
      font-size: 12px;
    }
  }
}
</style>
